module.exports = __webpack_public_path__ + "img/f72.175ca417.png";